module.exports = __webpack_public_path__ + "static/media/TD.efe07290.png";